// extracted by mini-css-extract-plugin
module.exports = {"TitleWrap":"style_TitleWrap__2_YYH","Title":"style_Title__2dTLy","SubTitle":"style_SubTitle__by0e4"};